// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBxVEcbdk57carM5tFyETQExAbrvlxBHWM",
  authDomain: "steadywave.firebaseapp.com",
  projectId: "steadywave",
  storageBucket: "steadywave.firebasestorage.app",
  messagingSenderId: "806311996570",
  appId: "1:806311996570:web:a44d98aec66a4578760323",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const str = getStorage(app);
// Initialize Firebase
